import { render, staticRenderFns } from "./scientist.vue?vue&type=template&id=262829c9&scoped=true"
import script from "./scientist.vue?vue&type=script&lang=js"
export * from "./scientist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262829c9",
  null
  
)

export default component.exports